export const main = {
  red: 'red',
};
